import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserSettingsContext } from 'src/contexts/UserSettingsContext/UserSettingsContext';
import { useLanguageNavigation } from 'src/hooks/use-language-navigation';

const PostRegistrationRoute: React.FC = () => {
  const { userSettings } = useUserSettingsContext();
  const { getLocalizedPath } = useLanguageNavigation();

  if (!userSettings) {
    return null;
  }

  if (!!userSettings && !userSettings.postRegistrationFormCompletion) {
    return <Navigate to={getLocalizedPath('/post-registration')} replace />; // Redirect to the post-registration page if the user has not completed the post-registration form.
  }

  return (
    <>
      <Outlet />
    </>
  ); // Render children if post registration form is completed
};

export default PostRegistrationRoute;
